import { message } from "antd";

// Text into a message box at the cursor the way typing puts it there, so Ctrl+Z / Ctrl+Y undo and redo a
// paste (setting the box's value from code leaves it out of the browser's undo history). The box's own
// onChange runs as for typing. `fallback()` sets the value directly where the browser cannot do this.
export const insertTyped = (box, text, fallback) => {
  let done = false;
  if (box && typeof document.execCommand === "function") {
    box.focus();
    try {
      done = document.execCommand("insertText", false, text);
    } catch (err) {
      done = false;
    }
  }
  if (!done) fallback();
};

// A message's whole text (mentions as @Name), copied in one go however long it is.
export const copyMessageText = (msg) => {
  const text = String((msg && msg.text) || "").replace(/@\[([^\]]+)\]\(\d+\)/g, "@$1");
  if (!text.trim()) {
    message.info("This message has no text to copy");
    return;
  }
  const done = () => message.success("Message copied");
  const fallback = () => {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    try {
      if (document.execCommand("copy")) done();
      else message.error("Could not copy the message");
    } catch (err) {
      message.error("Could not copy the message");
    }
    document.body.removeChild(area);
  };
  if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, fallback);
  else fallback();
};
